export default [
    {
        path: '/heishop/promociones',
        name: 'heishop-promociones',
        meta: {
            layout: 'session'
        },
        component: () => import('VIEWS/heishop/Promociones.vue')
    },

]